"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const components_1 = require("@/common/components");
const string_utils_1 = require("@/common/string_utils");
function default_1({ watch, isInputMode, }) {
    const totalSettlementAmount = watch('total_settlement_amount') || 0;
    const fieldsToSubtract = [
        'production_cost',
        'packaging_cost',
        'delivery_cost',
        'labor_cost',
        'rent_cost',
        'donation_cost',
        'other_cost_1',
        'other_cost_2',
    ];
    const netProfitAmount = fieldsToSubtract.reduce((total, fieldName) => {
        const fieldValue = watch(fieldName) || 0;
        return total - Number(fieldValue);
    }, totalSettlementAmount);
    const amountColor = isInputMode
        ? '--gray-30'
        : netProfitAmount === 0
            ? '--gray-40'
            : netProfitAmount > 0
                ? '--gray-80'
                : '--error-main';
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "desc_column surface-bg" }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "desc_with_detail body1 gray-80" }, { children: [t('순수익'), (0, jsx_runtime_1.jsx)(components_1.DetailButtonDialog, { detail: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("h1", { children: t('순수익') }), (0, jsx_runtime_1.jsx)("p", { children: t('오늘까지 정산 받은 금액에서 나머지 비용을 제외한 금액이에요.') }), (0, jsx_runtime_1.jsx)("p", { children: t('[정산 받은 금액-(제작비+포장비+배송비+인건비+임대료+기부금+기타비용1+기타비용2) = 순수익]') })] }) })] })) })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "amount_column surface-bg body1", css: { color: `var(${amountColor})` } }, { children: (0, string_utils_1.money)(netProfitAmount) })), (0, jsx_runtime_1.jsx)("div", { className: "file_column surface-bg" })] }));
}
exports.default = default_1;
